import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import { sizes } from '@lmc/common/constants'
import { Spinner } from '../../../components/generic'
import ResidentStockItem from './components/ResidentStockItem'
import SuccessMessage from './components/SuccessMessage'
import { Card, EmptyState, NoDataIcon, PageHeader } from '@lmc/ui-kit'
import { EmptyStateDescription } from '@lmc/ui-kit/src/dataDisplay/EmptyState'
import { getNominative } from '@lmc/common/utils'

export function StockAlertsReportScreen(props) {
  const {
    fetchMedications,
    isLoading,
    stockReport,
    preferredPeopleNominative,
  } = props

  React.useEffect(() => {
    fetchMedications()
  }, [])

  if (isLoading || !stockReport) return <Spinner />

  const showSuccess = stockReport.length === 0

  const showEmptyState =
    stockReport.filter(({ resident, emarResidentMeds }) => {
      return (
        emarResidentMeds &&
        emarResidentMeds?.length &&
        resident &&
        resident?.name
      )
    }).length === 0

  const stocksLink =
    'https://support.logmycare.co.uk/en/articles/5249509-how-does-expected-stock-work'
  return (
    <div style={styles.container}>
      <PageHeader title="Stock Levels" />
      <div style={styles.bodyContainer}>
        {showSuccess ? (
          <SuccessMessage />
        ) : showEmptyState ? (
          <Card>
            <EmptyState
              title="No stock information has been added yet"
              description={
                <>
                  <EmptyStateDescription>
                    Try adding Stock under the{' '}
                    {getNominative(preferredPeopleNominative, 'resident')}'s
                    Medications.
                    <br />
                    Learn more about how to add stocks{' '}
                    <a
                      style={{ textDecoration: 'underline' }}
                      href={stocksLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      here
                    </a>
                    .
                  </EmptyStateDescription>
                </>
              }
              icon={<NoDataIcon />}
            />
          </Card>
        ) : (
          stockReport.map(({ resident, emarResidentMeds }) => (
            <ResidentStockItem
              key={resident.id}
              resident={resident}
              emarResidentMeds={emarResidentMeds}
            />
          ))
        )}
      </div>
    </div>
  )
}

StockAlertsReportScreen.propTypes = {
  fetchMedications: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  stockReport: PropTypes.array.isRequired,
  preferredPeopleNominative: PropTypes.string,
}

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '24px 24px',
    position: 'relative',
  },
  bodyContainer: { paddingTop: 24 },
  filterContainer: {
    display: 'flex',
    marginTop: 16,
  },
}

const mapStateToProps = (state, props) => ({
  stockReport: Selectors.getStockLevelReport(state),
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  isLoading: !state.data['emar-resident-medications'] || !state.data.residents,
})

const mapDispatchToProps = (dispatch) => ({
  fetchMedications: () =>
    dispatch(Operations.loadList('emar-resident-medications', { stock: true })),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StockAlertsReportScreen)
